<template>
	<div v-if="game" @click="onClick" class="play-game-button">
		<info-tooltip v-if="!hasPermission" title="Login to play" ref="tooltip" :visible-on-hover="true" :visible-on-load="false" :offset="33" @click.native.stop>
			<p>In order to play a game, you need to be logged into an account.</p>
			<p>
				<a @click.prevent="redirectToLogin" class="clickable link--underlined">
					<span>Login</span>
				</a>
				or
				<a class="link--underlined" href="mailto:ilotteryshowcaseinquiry@igt.com?subject=IGT Lottery Showcase - Request Account">Inquire about an account</a>
			</p>
		</info-tooltip>
		<btn v-if="$mq === 'mob' || $mq === 'ptab'" class="min-w--217--not-phab min-w--168--phab" :disabled="!hasPermission" :link="$root.getGameDemo(game)" target="_blank">{{ text || "Play Game" }}</btn>
		<btn v-else class="w--100p" :disabled="!hasPermission" @click="$root.$data.gameDemo = game">{{ text || "Play Game" }}</btn>
	</div>
</template>

<script>
import Btn from '../atoms/Btn'
import InfoTooltip from '../molecules/InfoTooltip'

export default {
	name: 'PlayGameButton',
	components: {
		Btn,
		InfoTooltip,
	},
	data () {
		return {
		}
	},
	props: {
		game: Object,
		text: {
			type: String,
			default: 'Play Game'
		},
	},
	computed: {
		hasPermission: function()
		{
			var self = this;
			return self.$root.userHasPermission({
				'igt': ['AM', 'CM', 'SA'],
				'operator': ['customer', 'performance'],
				'guest': ['guest'],
			});
		}
	},
	created: function()
	{
	},
	mounted: function()
	{
	},
	methods: {
		onClick(evt)
		{
			var self = this;
			if(!self.hasPermission)
			{
				evt.preventDefault();
				evt.stopPropagation();
				self.$refs.tooltip.isVisible = true;
			}
			else
			{
				self.trackEvent([
					'game-demo-clicked',
					self.game.gameName,
					self.$root.$data.user ? self.$root.$data.user.trackName : null,
					0,
					false
				]);
			}
		},
		redirectToLogin: function()
		{
			var self = this;

			self.$root.$data.loginRedirect = {
				name: self.$route.name,
				params: self.$route.params,
				query: {
					'demo': self.game.id
				}
			};

			self.$router.push({ name: 'Login' });
		}
	}
}
</script>

<style lang="scss">
	@import "src/scss/toolkit";

	$c: ".play-game-button";
	#{$c}
	{
		display: inline-block;
		min-width: 168px;

		@include media(not-phab)
		{
			min-width: 217px;
		}
	}

</style>



// WEBPACK FOOTER //
// src/components/organisms/PlayGameButton.vue